'use client'

import { Grid, Typography, TypographyProps, styled } from '@mui/material'
import Image from 'next/image'

interface ImageData {
  imageSrc?: string
  imageAlt?: string
  heading: string
  text: string
  imgWidth?: number
  imgHeight?: number
}

interface Props {
  data: ImageData[]
  headerComponent?: string
  headerVariant?: TypographyProps['variant']
}

const ThreeColImageHeadingTextGrid = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.up('mdplus')]: {
    '& .MuiGrid-grid-mdplus-4': {
      paddingRight: theme.spacing(5),
      '&:last-of-type': {
        paddingRight: 0
      }
    }
  }
}))

const ThreeColImageHeadingText: React.FC<Props> = ({ data, headerComponent, headerVariant }) => {
  return (
    <ThreeColImageHeadingTextGrid container>
      {data.map((item, index) => (
        <Grid key={index} item xs={12} mdplus={4}>
          {item.imageSrc && (
            <Image
              src={item.imageSrc}
              alt={item.imageAlt ?? ''}
              width={item.imgWidth ?? 178}
              height={item.imgHeight ?? 187}
            />
          )}
          <Typography
            variant={headerVariant ?? 'h3'}
            {...(headerComponent && { component: headerComponent })}
          >
            {item.heading}
          </Typography>
          <Typography variant="body1">{item.text}</Typography>
        </Grid>
      ))}
    </ThreeColImageHeadingTextGrid>
  )
}

export default ThreeColImageHeadingText
